export default __webpack_public_path__ + "static/media/tradingview_copy_msg_ps.400b3e83.png";